<template>
  <div
    id="addendum-detail-content"
    class="detail-summay-containter"
  >
    <tender-head
      ref="tenderEditHead"
      :tenderGeneral="currentTender.general"
    >
      <button
        v-if="isPicView || isRepresentative"
        v-note="{text:noteText, enable:!editable}"
        :disabled="!editable"
        type="button"
        class="btn btn--darkblue nav-btn-top"
        @click="goEdit()"
      >{{ $t('action.edit') }}</button>
      <CancelAddendum
        v-if="isPicView"
        :disabled="!editable"
        :clickCheck="editableCheck"
      />
      <SubmitAddendum
        v-if="isPicView && isFromSubmit"
        class="nav-btn-top"
        :isUnderEditing="!editable"
        :clickCheck="editableCheck"
        :validateClosingDate="validateClosingDate"
      />
    </tender-head>
    <div class="detail-summay-accordion-container">
      <ul
        id="detail-summay-accordion"
        class="accordion accordion-main accordion-customize"
        data-accordion
        data-deep-link="true"
        data-allow-all-closed="true"
        data-multi-expand="true"
        data-update-history="true"
        data-deep-link-smudge="500"
      >
        <li
          class="accordion-item"
          data-accordion-item
        >
          <a
            href="#detail-summary-tabs"
            class="accordion-title"
          ><span>{{ $t('summary.name') }}</span></a>
          <div
            class="accordion-content"
            data-tab-content
            id="detail-summary-tabs"
          >
            <div>
              <Addendum :isBid="false" />
            </div>
          </div>
        </li>
        <li
          class="accordion-item is-active"
          data-accordion-item
        >
          <a
            href="#detail-summary-tabs"
            class="accordion-title"
          ><span>{{ $t('tender.detail') }}</span></a>
          <div
            class="accordion-content"
            data-tab-content
            id="detail-summary-tabs"
          >
            <div>
              <div v-if="!isPreview">
                <closing-date
                  ref="closingDateAddendum"
                  :partialClosingDate="partialClosingDate"
                  @update:partialClosingDate="val => partialClosingDate = val"
                />
              </div>
              <Tender>
                <button
                  v-if="isPicView || isRepresentative"
                  type="button"
                  class="btn btn--darkblue nav-btn-top mini-btn"
                  v-note="{text:noteText, enable:!editable}"
                  :disabled="!editable"
                  @click="goEdit()"
                >{{ $t('action.edit') }}</button>
                <CancelAddendum
                  v-if="isPicView"
                  class="nav-btn-top"
                  :className="'btn btn--darkblue mini-btn'"
                  :disabled="!editable"
                  :clickCheck="editableCheck"
                />
                <SubmitAddendum
                  v-if="isPicView && isFromSubmit"
                  class="nav-btn-top"
                  :className="'btn btn--orange mini-btn'"
                  :isUnderEditing="!editable"
                  :clickCheck="editableCheck"
                  :validateClosingDate="validateClosingDate"
                />
              </Tender>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <TenderRepresentative v-show="showTenderRep" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { tenderStatus } from '@/utils/locale'
import checkEditableMixin from '@/modules/tenders/checkEditableMixin'

import Addendum from '@/modules/tenders/review/Addendum'
import CancelAddendum from '@/modules/tenders/addendum/CancelAddendum'
import ClosingDate from '@/modules/tenders/ClosingDate'
import SubmitAddendum from '@/modules/tenders/addendum/SubmitAddendum'
import Tender from '@/modules/tenders/review/detail/Tender'
import TenderHead from '@/modules/tenders/TenderHead'
import tenderRepShowMixin from '@/modules/tenders/tenderRepShowMixin'
import TenderRepresentative from '@/modules/tenders/view/TenderRepresentative'

export default {
  mixins: [checkEditableMixin, tenderRepShowMixin],
  components: {
    Tender,
    Addendum,
    TenderHead,
    SubmitAddendum,
    CancelAddendum,
    ClosingDate,
    TenderRepresentative,
  },
  data () {
    return {
      isFromSubmit: false,
      tenderId: null,
      partialClosingDate: false,
    }
  },
  methods: {
    ...mapActions('tenders', [
      'loadTender',
      'validateRoute',
      'loadRecentRevision',
    ]),
    async goEdit () {
      await this.editableCheck()
      if (!this.editable) return
      let editview = this.isContractor ? 'tenderAddendumDetailsExt' : 'tenderAddendumDetails'
      this.$router.push({
        name: editview,
        params: {
          isEditing: true,
          id: this.tenderId,
        },
      })
    },
    async editableCheck () {
      await this.checkEditable(this.tenderId)
      return this.editable
    },
    validateClosingDate () {
      return this.closingDateChangeRequested ? this.$refs.closingDateAddendum.validate() : true
    },
  },
  async mounted () {
    if (!this.summaryAccordion) {
      this.summaryAccordion = new Foundation.Accordion(($('#detail-summay-accordion')))
    }
    this.tenderId = this.$router.currentRoute.params.id
    await this.loadTender(this.tenderId)
    this.isFromSubmit = this.$router.currentRoute.params.isFromSubmit || (!this.isDraft && !this.isRejected)
    if (!this.validateRoute()) return
    await this.loadRecentRevision({ loadPendingAddendum: true })
    // check edit button status for rep review
    if (this.isPicView || this.isRepresentative) {
      await this.checkEditable(this.tenderId)
    }
  },
  destroyed () {
    if (this.summaryAccordion) {
      this.summaryAccordion.destroy()
    }
  },
  computed: {
    ...mapGetters('tenders', ['currentTender', 'isPicView', 'isTender', 'isRepresentative']),
    ...mapGetters('user', {
      isContractor: 'isContractor',
    }),
    isPreview () {
      return this.currentTender.general.status === tenderStatus.DRAFT ||
          this.currentTender.general.status === tenderStatus.WAPPR || this.currentTender.general.status === tenderStatus.REJECTED
    },
    closingDateChangeRequested () {
      return this.currentTender.general.closingDateExtended
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/stickyBtn";
@import '~styles/accordion';
.nav-btn-top {
  vertical-align: top;
}
</style>

<style lang="scss">
#addendum-detail-content {
  .create-tender-main{
    background: #ffffff;
    padding: 0;
  }
}
</style>
